import { useMutation } from '@tanstack/react-query'

import { intentionApi } from '../api/intentionApi'

export const useMarkIntentionsAsViewedMutation = () =>
  useMutation({
    mutationFn: (ids: number[]) => intentionApi.markIntentionsAsViewed(ids),
  })
